var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboCaratDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 19 10",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27017 0.214879L8.71017 6.65488C8.91017 6.85488 9.22017 6.85488 9.42017 6.65488L15.8502 0.214878C15.9402 0.124878 16.0702 0.0648777 16.2002 0.0648777L17.6202 0.0648776C18.0702 0.0648775 18.2902 0.604877 17.9702 0.914878L9.41017 9.47488C9.21017 9.67488 8.90017 9.67488 8.70017 9.47488L0.14017 0.914879C-0.169829 0.604879 0.0501701 0.0648791 0.490171 0.0648791L1.90017 0.0648789C2.03017 0.0648789 2.16017 0.114879 2.25017 0.214879L2.27017 0.214879Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboCaratDown);
export default __webpack_public_path__ + "static/media/FBOCaratDown.bc2e568104db9f75407247a897e7873b.svg";
export { ForwardRef as ReactComponent };